import { render } from "./HeaderApp.vue?vue&type=template&id=baf3f0b6&lang=true"
import script from "./HeaderApp.vue?vue&type=script&lang=js"
export * from "./HeaderApp.vue?vue&type=script&lang=js"

import "./HeaderApp.vue?vue&type=style&index=0&id=baf3f0b6&lang=scss"

import exportComponent from "/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__